import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type ClientProfile = Database['public']['Tables']['client_profiles']['Row'];
type ClientProfileInsert = Database['public']['Tables']['client_profiles']['Insert'];
type ClientProfileUpdate = Database['public']['Tables']['client_profiles']['Update'];

interface ProfileCompletion {
  completed: boolean;
  percentage: number;
  completedFields: number;
  totalFields: number;
}

export const clientService = {
  /**
   * Get current user's client profile
   */
  getMyProfile: (): Promise<ClientProfile> => 
    apiClient.get<ClientProfile>('/profiles/client/me') as unknown as Promise<ClientProfile>,
  
  /**
   * Get client profile by ID (public endpoint)
   */
  getProfile: (profileId: string): Promise<ClientProfile> => 
    apiClient.get<ClientProfile>(`/profiles/client/${profileId}`) as unknown as Promise<ClientProfile>,
  
  /**
   * Get current user's client profile ID
   */
  getMyProfileId: (): Promise<{ id: string }> => 
    apiClient.get<{ id: string }>('/profiles/client/me/id') as unknown as Promise<{ id: string }>,
  
  /**
   * Get current user's client profile completion status
   */
  getCompletion: (): Promise<ProfileCompletion> => 
    apiClient.get<ProfileCompletion>('/profiles/client/me/completion') as unknown as Promise<ProfileCompletion>,
  
  /**
   * Create client profile for current user
   */
  createProfile: (data: Omit<ClientProfileInsert, 'user_id'>): Promise<ClientProfile> => 
    apiClient.post<ClientProfile>('/profiles/client/me', data) as unknown as Promise<ClientProfile>,
  
  /**
   * Update current user's client profile
   */
  updateProfile: (data: ClientProfileUpdate): Promise<ClientProfile> => 
    apiClient.patch<ClientProfile>('/profiles/client/me', data) as unknown as Promise<ClientProfile>,
};

